'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
type Props = {
  className?: string;
  imageSrc?: string;
  title?: string;
  price?: string;
  priceNote?: string;
  plan?: string;
  publications?: string;
  ribbonText?: string;
  includesText?: string;
  description?: string;
  disclaimer?: string;
  previewLabel?: string;
  ctaLabel?: string;
  onBuy?: () => void;
};
export default function BuyDinamani(t0) {
  const $ = _c(54);
  const {
    className: t1,
    imageSrc: t2,
    title: t3,
    price: t4,
    priceNote: t5,
    plan: t6,
    publications: t7,
    ribbonText: t8,
    includesText: t9,
    description: t10,
    disclaimer: t11,
    previewLabel: t12,
    ctaLabel: t13,
    onBuy
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const imageSrc = t2 === undefined ? "https://media.dinamani.com/dinamani/2026-02-27/pm7gpn7o/dummy.png" : t2;
  const title = t3 === undefined ? "Dinamani - Perambalur & Ariyalur" : t3;
  const price = t4 === undefined ? "Buy @\u20B9750" : t4;
  const priceNote = t5 === undefined ? "+ applicable taxes" : t5;
  const plan = t6 === undefined ? "1 Yr Plan" : t6;
  const publications = t7 === undefined ? "7 Publications" : t7;
  const ribbonText = t8 === undefined ? "Recommended" : t8;
  const includesText = t9 === undefined ? "Includes Yearly Subscription" : t9;
  const description = t10 === undefined ? "The yearly E-paper subscription of Dinamani comes with Gnayiru-Kondattam and Kadir" : t10;
  const disclaimer = t11 === undefined ? "No refunds are allowed" : t11;
  const previewLabel = t12 === undefined ? "Preview" : t12;
  const ctaLabel = t13 === undefined ? "Buy Dinamani - Perambalur & Ariyalur" : t13;
  const t14 = `relative border border-DCDCDC bg-FFFFFF m-4 ${className}`;
  let t15;
  if ($[0] !== ribbonText) {
    t15 = <div className="absolute -top-3 left-3 rounded-full bg-FFDB59 px-3 py-1 text-12-tamil600 text-222222 shadow">{ribbonText}</div>;
    $[0] = ribbonText;
    $[1] = t15;
  } else {
    t15 = $[1];
  }
  let t16;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="h-[200px] w-full bg-gradient-to-b from-E6F8FD to-transparent rounded-t-md" />;
    $[2] = t16;
  } else {
    t16 = $[2];
  }
  let t17;
  if ($[3] !== imageSrc) {
    t17 = <div className="absolute left-[50%] -translate-x-1/2 -top-[-10%] w-[170px] h-[120px] rotate-[-6deg] drop-shadow"><Image src={imageSrc} alt="Newspaper" fill={true} className="object-cover rounded-sm" /></div>;
    $[3] = imageSrc;
    $[4] = t17;
  } else {
    t17 = $[4];
  }
  let t18;
  if ($[5] !== title) {
    t18 = <div className="pr-4"><h3 className="text-18-tamil-600 text-222222">{title}</h3></div>;
    $[5] = title;
    $[6] = t18;
  } else {
    t18 = $[6];
  }
  let t19;
  if ($[7] !== price) {
    t19 = <div className="text-18-tamil-600 text-012061">{price}</div>;
    $[7] = price;
    $[8] = t19;
  } else {
    t19 = $[8];
  }
  let t20;
  if ($[9] !== priceNote) {
    t20 = <div className="text-12-tamil-400 text-6C6C6C">{priceNote}</div>;
    $[9] = priceNote;
    $[10] = t20;
  } else {
    t20 = $[10];
  }
  let t21;
  if ($[11] !== t19 || $[12] !== t20) {
    t21 = <div className="text-right">{t19}{t20}</div>;
    $[11] = t19;
    $[12] = t20;
    $[13] = t21;
  } else {
    t21 = $[13];
  }
  let t22;
  if ($[14] !== t18 || $[15] !== t21) {
    t22 = <div className="flex items-start justify-between">{t18}{t21}</div>;
    $[14] = t18;
    $[15] = t21;
    $[16] = t22;
  } else {
    t22 = $[16];
  }
  let t23;
  if ($[17] !== plan) {
    t23 = <span>{plan}</span>;
    $[17] = plan;
    $[18] = t23;
  } else {
    t23 = $[18];
  }
  let t24;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className="h-[3px] w-[3px] rounded-full bg-9CA3AF inline-block" />;
    $[19] = t24;
  } else {
    t24 = $[19];
  }
  let t25;
  if ($[20] !== publications) {
    t25 = <span>{publications}</span>;
    $[20] = publications;
    $[21] = t25;
  } else {
    t25 = $[21];
  }
  let t26;
  if ($[22] !== t23 || $[23] !== t25) {
    t26 = <div className="mt-2 flex items-center gap-3 text-14-tamil-400 text-6C6C6C">{t23}{t24}{t25}</div>;
    $[22] = t23;
    $[23] = t25;
    $[24] = t26;
  } else {
    t26 = $[24];
  }
  let t27;
  if ($[25] !== includesText) {
    t27 = <div className="absolute -top-3 right-3 rounded bg-E24E45 px-2 py-[2px] text-12-tamil-400 text-FFFFFF">{includesText}</div>;
    $[25] = includesText;
    $[26] = t27;
  } else {
    t27 = $[26];
  }
  let t28;
  if ($[27] !== description) {
    t28 = <p className="text-15-tamil-400 text-222222">{description}</p>;
    $[27] = description;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] !== disclaimer) {
    t29 = <span className="text-13-tamil-400 text-6C6C6C">{disclaimer}</span>;
    $[29] = disclaimer;
    $[30] = t29;
  } else {
    t29 = $[30];
  }
  let t30;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span aria-hidden={true}>›</span>;
    $[31] = t30;
  } else {
    t30 = $[31];
  }
  let t31;
  if ($[32] !== previewLabel) {
    t31 = <button type="button" className="text-14-tamil-600 text-012061 inline-flex items-center gap-1">{previewLabel}{t30}</button>;
    $[32] = previewLabel;
    $[33] = t31;
  } else {
    t31 = $[33];
  }
  let t32;
  if ($[34] !== t29 || $[35] !== t31) {
    t32 = <div className="mt-4 flex items-center justify-between">{t29}{t31}</div>;
    $[34] = t29;
    $[35] = t31;
    $[36] = t32;
  } else {
    t32 = $[36];
  }
  let t33;
  if ($[37] !== t27 || $[38] !== t28 || $[39] !== t32) {
    t33 = <div className="mt-4 rounded-md bg-E6F8FD p-4 relative">{t27}{t28}{t32}</div>;
    $[37] = t27;
    $[38] = t28;
    $[39] = t32;
    $[40] = t33;
  } else {
    t33 = $[40];
  }
  let t34;
  if ($[41] !== ctaLabel || $[42] !== onBuy) {
    t34 = <button type="button" onClick={onBuy} className="mt-4 w-full rounded-[4px] bg-FFDB59 px-4 py-3 text-center text-15-tamil-600 text-222222 hover:bg-[#FFC34D]">{ctaLabel}</button>;
    $[41] = ctaLabel;
    $[42] = onBuy;
    $[43] = t34;
  } else {
    t34 = $[43];
  }
  let t35;
  if ($[44] !== t22 || $[45] !== t26 || $[46] !== t33 || $[47] !== t34) {
    t35 = <div className="px-4 pb-4 pt-2">{t22}{t26}{t33}{t34}</div>;
    $[44] = t22;
    $[45] = t26;
    $[46] = t33;
    $[47] = t34;
    $[48] = t35;
  } else {
    t35 = $[48];
  }
  let t36;
  if ($[49] !== t14 || $[50] !== t15 || $[51] !== t17 || $[52] !== t35) {
    t36 = <div className={t14}>{t15}{t16}{t17}{t35}</div>;
    $[49] = t14;
    $[50] = t15;
    $[51] = t17;
    $[52] = t35;
    $[53] = t36;
  } else {
    t36 = $[53];
  }
  return t36;
}